import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import Button from "@mui/material/Button";
import AssignmentIcon from "@mui/icons-material/Assignment";
import IconButton from "@mui/material/IconButton";
import ExpandLess from "@mui/icons-material/ExpandLess";

import {
  setLookDemoPointsClicked, setLookIntroStep, setLookOpened, setLookOverlayOpened, setLookPageOpened, setLookParentKeys
} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import {LOCAL_STORAGE_KEYS, LOOK_INTRO_STEPS, LOOK_OPENED_TYPES} from "../../core/constants";
import LookFooterCounts from "./lookFooterCounts";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import LookIntroFooterAnchor from "../lookIntro/lookIntroFooterAnchor";
import {setLocalStorageItem} from "../../../../misc/storageFunctions";
import {pricingIsLocked} from "../lookNavigationFunctions";

const LookFooter = (props) => {

  const {lookOpened, setLookOpened, lookActiveFeature, intl, history, introStep, setLookOverlayOpened,
    visualizersLoadedLength, setLookDemoPointsClicked, setLookPageOpened, setLookIntroStep, fabricatorSettings,
    isPhoneNumberValidated} = props;

  const lookButtonClick = () => {

    Analytics.sendClickEvent(
      lookOpened ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFooterCloseMenu : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFooterExpandMenu
    );

    if (!visualizersLoadedLength) {
      return false
    }

    if (introStep === LOOK_INTRO_STEPS.review) {
      return false;
    }

    setLookOpened(lookOpened ? null : LOOK_OPENED_TYPES.edit);
    if (!lookOpened) {
      setLookDemoPointsClicked(true);
    }
  }

  let buyNow = false;
  const getQuote = fabricatorSettings.enableQuote && !isPhoneNumberValidated;
  let {showPrice, isLixil} = pricingIsLocked();
  if (!isLixil && fabricatorSettings.enableQuote && showPrice) {
    buyNow = isPhoneNumberValidated && fabricatorSettings.checkout && fabricatorSettings.hasPaymentGateway;
  }

  const yourListButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookFooterList);
    if (introStep === LOOK_INTRO_STEPS.review) {
      setLookOverlayOpened("");
      setLocalStorageItem(LOCAL_STORAGE_KEYS.introVisited, true);
      setLookIntroStep(LOOK_INTRO_STEPS.welcome);  // to prevent button active highlighting
    }
    if (lookOpened) {
      setLookOpened(null);
    }
    if (buyNow) {
      setLookPageOpened(ROUTES.cart);
      history.push(ROUTES.cart);
    } else {
      setLookPageOpened(ROUTES.list);
      history.push(ROUTES.list);
    }
  }

  const getYourListButtonText = () => {
    if (buyNow) {
      return "footer.listButton.getQuote.buyNow"
    } else if (getQuote) {
      return "footer.listButton.getQuote"
    } else {
      return "footer.listButton"
    }
  }

  const expandDisabled = ((introStep !== LOOK_INTRO_STEPS.welcome) && (introStep === LOOK_INTRO_STEPS.review));

  return (
    <footer className={"lm-footer" + (lookOpened ? " lm-footer--opened" : " lm-footer--closed")
      + (lookOpened && lookActiveFeature ? " lm-footer--slide-left" : "")}>
      <IconButton aria-label={intl.formatMessage({id:"tooltip.editLook"})}
                  disabled={expandDisabled}
                  className={"look-icon look-icon--small" + (lookOpened ? " look-icon--rotated" : "")}
                  onClick={lookButtonClick}>
        <ExpandLess/>
      </IconButton>
      <div className="lm-footer__main">
        <LookFooterCounts/>
        <Button className={"look-button look-button--primary"}
                startIcon={<AssignmentIcon/>}
                onClick={yourListButtonClick}>
          <FormattedMessage id={getYourListButtonText()}/>
        </Button>
      </div>
      <LookIntroFooterAnchor/>
    </footer>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {lookOpened, introStep, lookParentKeys, lookActiveFeature} = store.lookState;
  const {isPhoneNumberValidated} = store.userState;
  const {settings} = store.fabricatorState;

  return {
    lookOpened,
    introStep,
    lookParentKeys,
    lookActiveFeature,
    visualizersLoadedLength: visualizersLoaded.length,
    fabricatorSettings: settings,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookIntroStep,
  setLookOverlayOpened,
  setLookParentKeys,
  setLookDemoPointsClicked,
  setLookPageOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookFooter)
  )
)
